import React from 'react';

function NavigationWidgets({ widgets }) {
  if (!widgets.length) { return null; }

  function widgetsContents() {
    return widgets.map(widget =>
      <div
        dangerouslySetInnerHTML={{ __html: widget.content }}
        id={widget.id_name}
        className={widget.css_name}
        key={widget.id}
      />
    );
  }

  return (
    <li className="navigation-widgets">
      {widgetsContents()}
    </li>
  );
}

NavigationWidgets.propTypes = {
  widgets: React.PropTypes.array
};

export default NavigationWidgets;



// WEBPACK FOOTER //
// ./components/navigationWidgets.js